import React, { useEffect, useState } from 'react';

export default function IntroSequence() {
  const [visible, setVisible] = useState(() => {
    if (typeof window === 'undefined') return false;
    return !window.matchMedia('(prefers-reduced-motion: reduce)').matches
      && !sessionStorage.getItem('vroom_intro_seen');
  });

  useEffect(() => {
    if (!visible) return undefined;
    sessionStorage.setItem('vroom_intro_seen', '1');
    const timeout = window.setTimeout(() => setVisible(false), 900);
    return () => window.clearTimeout(timeout);
  }, [visible]);

  if (!visible) return null;
  return (
    <div className="dl-intro" aria-hidden="true">
      <div className="dl-intro-panel dl-intro-panel-left" />
      <div className="dl-intro-panel dl-intro-panel-right" />
      <div className="dl-intro-mark">
        <span className="dl-intro-word">VROOM</span>
        <span className="dl-intro-line" />
      </div>
    </div>
  );
}
